import React from "react";
import { TextInput, Filter, RefreshButton, CreateButton } from "admin-on-rest";

import { CardActions } from "material-ui/Card";
import { styles } from "./styles";

// export const typePayment = [
//   { id: "bank_transfer", name: "Bank Transfer" },
//   { id: "cicilan", name: "Cicilan" },
//   { id: "credit_card", name: "Credit Card" }
// ];

export const typePayment = [
  { id: "cicilan", name: "Cicilan" }
];

export const paymentDefaultValue = {
  active: false,
  logo: "",
  type:"cicilan",
  terms: []
};
export const validatePayment = values => {
  const errors = {};
  if (!values.name) {
    errors.name = ["Name is required"];
  } else if (values.name.trim().length <= 0) {
    errors.name = ["Name is required"];
  }
  if (!values.type) {
    errors.type = ["Type is required"];
  } else if (values.type.trim().length <= 0) {
    errors.type = ["Type is required"];
  }
  return errors;
};

export const PaymentFilter = ({ ...props }) => (
  <Filter {...props}>
    {permissions => [
      <TextInput label="resources.actions.search" source="search" alwaysOn />
    ]}
  </Filter>
);

export const PaymentActions = ({
  resource,
  filters,
  displayedFilters,
  filterValues,
  basePath,
  showFilter,
  refresh
}) => (
  <CardActions style={styles.cardActionStyleSmall} className="detail-actions">
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button"
      })}
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/payment/defaultValues.js